import { Node, mergeAttributes } from '@tiptap/core';
var TaskList = Node.create({
  name: 'taskList',
  addOptions: function addOptions() {
    return {
      itemTypeName: 'taskItem',
      HTMLAttributes: {}
    };
  },
  group: 'block list',
  content: function content() {
    return "".concat(this.options.itemTypeName, "+");
  },
  parseHTML: function parseHTML() {
    return [{
      tag: "ul[data-type=\"".concat(this.name, "\"]"),
      priority: 51
    }];
  },
  renderHTML: function renderHTML(_ref) {
    var HTMLAttributes = _ref.HTMLAttributes;
    return ['ul', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, {
      'data-type': this.name
    }), 0];
  },
  addCommands: function addCommands() {
    var _this = this;

    return {
      toggleTaskList: function toggleTaskList() {
        return function (_ref2) {
          var commands = _ref2.commands;
          return commands.toggleList(_this.name, _this.options.itemTypeName);
        };
      }
    };
  },
  addKeyboardShortcuts: function addKeyboardShortcuts() {
    var _this2 = this;

    return {
      'Mod-Shift-9': function ModShift9() {
        return _this2.editor.commands.toggleTaskList();
      }
    };
  }
});
export { TaskList, TaskList as default };